<template>
  <div class="form-switch" :class="newClasses">
    <label class="form-switch--label" :for="'switch-' + name">{{$t(newLabel)}}</label>
    <div class="switch-container" @click="valueSwitch" :id="'switch-' + name">
      <div class="switch-button"></div>
    </div>
  </div>
</template>
<script>
import Field from "@/components/helpers/DataInput/Field";
export default {
  components: { Field },
  data() {
    return {
      newValue: false
    };
  },
  props: {
    label: String,
    name: String,
    value: Boolean,
    reverse: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: () => {}
    },
    errors: {
      type: Array,
      default: () => []
    },
    model: String
  },
  methods: {
    valueSwitch() {
      this.newValue = !this.newValue;
    }
  },
  computed: {
    newClasses() {
      if (this.newValue === undefined) {
        return "value-undefined";
      }
      if (this.reverse === true) {
        return "value-" + !this.newValue;
      } else {
        return "value-" + this.newValue;
      }
    },
    newLabel() {
      if (this.label) {
        if (this.label === "empty") {
          return "";
        }
        return this.label;
      } else {
        return "models." + this.model + "." + this.name;
      }
    }
  },
  // this is the git flow test
  mounted() {
    this.newValue = this.value;
  },
  watch: {
    value(val) {
      if (val !== this.newValue) {
        this.newValue = val;
      }
    },
    newValue(val) {
      this.$emit("input", val);
    }
  }
};
</script>
<style lang="scss">
.form-switch {
  display: block;
  label {
    font-size: 16px;
    font-weight: $font-medium;
    white-space: nowrap;
    color: $ink-dark !important;
  }
}
.switch-container {
  width: 36px;
  min-width: 36px;
  height: 20px;
  background-color: $sensual;
  border-radius: 10px;
  position: relative;
  cursor: pointer;
  transition: all 250ms ease-in-out;
  margin-top: 0.5em;
}
.switch-button {
  width: 16px;
  height: 16px;
  background-color: $paper-lighter;
  border-radius: 18px;
  margin: 2px;
  position: absolute;
  transition: all 250ms ease-in-out;
  left: 0;
}
.value-false {
  .switch-container {
    background-color: $paper-dark;
  }
  .switch-button {
    // left: 0;
    right: 0;
    background-color: #fff;
  }
}
.value-undefined {
  opacity: 0.6;
  .switch-container {
    background-color: $sensual-lighter;
  }
  .switch-button {
    // left: 0;
    right: 0;
    background-color: #fff;
  }
}
.value-true {
  .switch-button {
    left: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// FormSwitch.vue?b9543efe